<div>
  <nav class="navbar ">
    <div class="container" style="position:relative">
     <img src="\assets\img\header1.png" alt="logo" style="width:70%">
          <h4 style="color:red; position:absolute; right:10px; bottom:0 ">{{inviNo}}</h4>
    </div>
  </nav>
</div>
<!--HON-INV-2102-->
